<div class="section-image-text">
    <div class="section-image-text--left">
      <h1>Upoznajte Kancelarijskinamestaj.rs</h1>
      <p>
        KancelarijskiNamestaj.rs je online prodavnica kancelarijskog nameštaja Osnovan 2012 godine sa vizijom
        proizvodnje i isporuke kvalitetnih proizvoda širom Srbije.
        Veliki deo uspeha proteklih godina dugujemo našem talentovanom i iskusnom timu, koji je posvećen izgradnji
        dugotrajnih odnosa pružanjem najvišeg nivoa usluga našim klijentima.
        Kao vodeći proizvođač u industriji kancelarijskog nameštaja, ponosni smo što imamo širok izbor rešenja koja
        zadovoljavaju potrebe naših klijenata na tržištu rada, obrazovanja, zdravstvene zaštite i kućnih kancelarija.
      </p>
    </div>
    <div class="section-image-text--right">
      <picture>
        <source srcset="https://cdn.streamlinedhq.com/QQEQKMYZEVGPYSTGUNDO/banner/planiranje-poslovnog-prostora.webp"
          type="image/webp">
        <source srcset="https://cdn.streamlinedhq.com/QQEQKMYZEVGPYSTGUNDO/banner/planiranje-poslovnog-prostora.png"
          type="image/png">
        <img class="pdp-clickable" title="Planiranje poslovnog prostora"
          routerLink='/info/page/opremanje-poslovnog-prostora/p1mfass'
          alt="Planiranje poslovnog prostora. Besplatno usluga planiranja poslovnog prostora"
          src="https://cdn.streamlinedhq.com/QQEQKMYZEVGPYSTGUNDO/banner/planiranje-poslovnog-prostora.png">
      </picture>
    </div>
  </div>